import { motion } from "framer-motion";
import ViewAllBtn from "../common/view-all";
import { useGalleryCtx } from "@/contexts/gallery";
import { usePerformance } from "../contexts/performance-context";
import { MainFilter, YearFilter, YearQuery } from "../common/filter";
import Card from "../common/card";
import { PerformanceSectionProps } from "../types/common";

export default function DesktopView({ data }: { data: PerformanceSectionProps }) {
  const { setCurrentGalleryItems, setCurrentGalleryItem } = useGalleryCtx();

  const {
    pageNo,
    year,
    type,
    loading,
    setPageNo,
    setYear,
    setType,
    loadingMore,
    performances,
    reachedEnd,
  } = usePerformance();

  function openExpandedView(index: number) {
    setCurrentGalleryItem(index);
    setCurrentGalleryItems(performances);
  }
  return (
    <motion.div
      key="default"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      transition={{ duration: 0.5 }}
      className="hidden lg:block"
    >
      <div className="flex justify-between pb-10">
        <h1 className="text-[48px] text-secondary ltr:font-playfair ltr:tracking-[-1.44px]">
          {data.title}
        </h1>
        <div className="flex gap-4">
          <MainFilter options={data.dropdown_text.values} type={type} setType={setType} />
          <YearFilter
            yearQuery={YearQuery.PERFORMANCE_YEAR}
            years={data.year_filter_text.years}
            year={year}
            setYear={setYear}
          />
        </div>
      </div>
      <div className="grid grid-cols-3 gap-6">
        {performances.map((perf, index) => (
          <Card item={perf} key={index} onClick={() => openExpandedView(index)} loading={loading} />
        ))}
      </div>
      <ViewAllBtn
        loadingMore={loadingMore}
        text={data.button_text}
        pageNo={pageNo}
        setPageNo={setPageNo}
        reachedEnd={reachedEnd}
      />
    </motion.div>
  );
}
